//#region IMPORT
import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import Header from '../../Components/Header';
import DashBoard from '../../Components/DashBoard';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import './Home.css';
import useResponsiveValue from '../../hooks/useResponsiveValue';
import PopBasicDashboardLayer from '../PopupManagement/POP_BASIC/POP_BASIC_DashboardLayer';
//#endregion

const theme = createTheme({
  typography: {
    fontFamily: "'Pretendard', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      '@media (min-width:600px) and (max-width:1199px)': {
        fontSize: '1rem',
      },
      '@media (min-width:1200px) and (max-width:1599px)': {
        fontSize: '1.05rem',
      },
      '@media (min-width:1600px) and (max-width:1919px)': {
        fontSize: '1.1rem ',
      },
      '@media (min-width:1920px)': {
        fontSize: '1.15rem',
      },
    },
    h2: {
      '@media (min-width:600px) and (max-width:1199px)': {
        fontSize: '0.95rem',
      },
      '@media (min-width:1200px) and (max-width:1599px)': {
        fontSize: '1rem',
      },
      '@media (min-width:1600px) and (max-width:1919px)': {
        fontSize: '1.05rem',
      },
      '@media (min-width:1920px)': {
        fontSize: '1.1rem',
      },
    },
  },

  palette: {
    primary: {
      light: '#008b43',
      main: '#008b43',
      dark: '#00b557',
      contrastText: '#fff',
    },
  },
});

function Home(props) {
  const leftWidth = useResponsiveValue([
    { min: 2560, value: '1788px' },
    { min: 2400, max: 2560, value: '1668px' },
    { min: 2133, max: 2400, value: '1467px' },
    { min: 1920, max: 2133, value: '1291px' },
    { min: 1745, max: 1920, value: '1166px' },
    { min: 1670, max: 1745, value: '1106px' },
    { min: 0, max: 1745, value: '1011px' },
  ]); // 조회조건영역, 데이터영역 카드 넓이
  const rightWidth = useResponsiveValue([
    { min: 2560, value: '596px' },
    { min: 2400, max: 2560, value: '556px' },
    { min: 2133, max: 2400, value: '490px' },
    { min: 1920, max: 2133, value: '453px' },
    { min: 1745, max: 1920, value: '389px' },
    { min: 1670, max: 1745, value: '400px' },
    { min: 0, max: 1745, value: '337px' },
  ]); // 조회조건영역, 데이터영역 카드 넓이

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Stack
        sx={{
          width: '100%',
          p: '10px 10px 0px 10px',
        }}
      >
        <Stack
          sx={{
            width: '100%',
            minHeight: '800px',
            alignItems: 'stretch',
          }}
        >
          <Header
            headerInputs={props.headerInputs}
            SearchLogic2={props.Search1}
            SearchLogic3={props.SearchLogic3}
            SearchLogic4={props.SearchLogic4}
            handleCoChange={props.handleCoChange}
            handleCustChange={props.handleCustChange}
          />
          <DashBoard
            noticeData={props.noticeData}
            newsData={props.newsData}
            seriousData={props.seriousData}
            seriousSummary={props.seriousSummary}
            alarmData={props.alarmData}
            alarmDetailData={props.alarmDetailData}
            workListData={props.workListData}
            calendarEvents={props.calendarEvents}
            myCalendars={props.myCalendars}
            onDateChange={props.onDateChange}
            onMonthChange={props.handleMonthChange}
            search2={props.search2}
            SaveLogic4={props.SaveLogic4}
            handleSaveLogic4={props.handleSaveLogic4}
            handleReadAll={props.handleReadAll}
            handleSaveWork={props.handleSaveWork}
            handleDeleteWork={props.handleDeleteWork}
            handleStatusChange={props.handleStatusChange}
            handlePriorityChange={props.handlePriorityChange}
            handlePinWork={props.handlePinWork}
            search6={props.search6}
            completeWorkListData={props.completeWorkListData}
          />
          <PopBasicDashboardLayer />
        </Stack>
      </Stack>
    </ThemeProvider>
  );
}

export default Home;
